import React, { useState, useEffect, useContext } from 'react';
import { MyContext } from '../MainContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faUserMd, 
    faArrowLeft,
    faPlus
} from '@fortawesome/free-solid-svg-icons';
import { useParams, useNavigate } from 'react-router-dom';
import Header from './header';
import Footer from './footer';
import { useCustomAlert } from './CustomAlert';

const GroupTherapy = () => {
    const { user } = useContext(MyContext);
    const { groupId } = useParams();
    const navigate = useNavigate();
    const { showAlert, AlertComponent } = useCustomAlert();

    return (
        <div className="min-vh-100 d-flex flex-column">
            <Header />
            
            <div className="container-fluid p-3 flex-grow-1" style={{ marginTop: '80px', marginBottom: '60px' }}>
                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="d-flex align-items-center">
                        <div>
                            <h2 className="mb-0">
                                <FontAwesomeIcon icon={faUserMd} className="me-2" />
                                Therapy Services
                            </h2>
                            <small className="text-muted">Professional support within the group</small>
                        </div>
                    </div>
                    <button 
                        className="btn btn-primary"
                        onClick={() => showAlert('info', 'Coming Soon', 'Therapy services feature coming soon!')}
                    >
                        <FontAwesomeIcon icon={faPlus} className="me-1" />
                        Request Therapy
                    </button>
                </div>

                {/* Coming Soon Message */}
                <div className="text-center py-5">
                    <FontAwesomeIcon icon={faUserMd} size="3x" className="text-muted mb-3" />
                    <h5 className="text-muted">Therapy Services Coming Soon</h5>
                    <p className="text-muted">
                        This feature will allow group members to access therapy services and professional support within the group.
                    </p>
                </div>
            </div>

            <Footer />

            {/* Custom Alert */}
            <AlertComponent />
        </div>
    );
};

export default GroupTherapy;
